import { CanDeactivateFn } from '@angular/router';
import { inject, INJECTOR } from '@angular/core';
import { LedControlService } from '../services/led-control.service';
import { CartService } from '../services/cart.service';
import { handleRequestError } from '@softline/application';

export const ledControlOffFn: CanDeactivateFn<unknown> = async () => {
  const ledControlService = inject(LedControlService);
  const injector = inject(INJECTOR);
  const cartService = inject(CartService);

  try {
    await cartService.discardEmptyCart();
    await ledControlService.signalOver();
  } catch (e) {
    handleRequestError(e, injector, { show: false });
  }

  cartService.clear();
  return true;
};
